import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/assets";

export default function Logo({ compact = false }) {
  return (
    <Link to="/" className="flex items-center gap-3 group" data-testid="site-logo">
      <img
        src={ASSETS.hammerBadge}
        alt="Sportsbook Smasher hammer"
        className="w-11 h-11 sm:w-14 sm:h-14 object-contain drop-shadow-[0_4px_12px_rgba(255,138,0,0.4)] group-hover:scale-105 transition-transform"
      />
      <div className="leading-none">
        <div className="font-heading font-extrabold tracking-tight text-lg sm:text-2xl">
          <span className="text-gradient-chrome">SPORTSBOOK</span>
        </div>
        <div className="font-heading font-black tracking-tight text-2xl sm:text-3xl -mt-1 text-gradient-gold">
          SMASHER
        </div>
        {!compact && (
          <div className="hidden sm:block text-[9px] font-semibold tracking-[0.18em] text-smasher-gold/80 mt-0.5">
            CRUSH EVERY PLAY. SMASH EVERY BET.
          </div>
        )}
      </div>
    </Link>
  );
}
